import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../helpers/src/react/reactHelpers';
import {useUserTheme} from '../../theme/userThemeProvider';
import {Icon} from '../icon/icon';
import {TooltipCoordinator} from '../tooltips/tooltipCoordinator';
import {VisuallyHidden} from '../visuallyHidden/visuallyHidden';
import {ChromelessButton} from './chromelessButton';

/*
 * Props.
 */

interface ExpandButtonProps {
  tooltip: ReactNode;
  onClick: Handler;
}

/*
 * Style.
 */

const StyledExpandButton = styled(ChromelessButton)`
  padding: 0 4px;
  border-radius: 10px;

  &:hover {
    background: ${(p) => p.theme.alphas.gray10};
  }
`;

/*
 * Component.
 */

export const ExpandButton: FC<ExpandButtonProps> = (props) => {
  const theme = useUserTheme();

  return (
    <TooltipCoordinator render={() => props.tooltip}>
      <StyledExpandButton onClick={props.onClick}>
        <Icon name="more" color={theme.greys.shade60} hoverColor={theme.greys.shade80} />
        <VisuallyHidden>{props.tooltip}</VisuallyHidden>
      </StyledExpandButton>
    </TooltipCoordinator>
  );
};
